module.exports = __webpack_public_path__ + "img/hk-flag.27aa65d0.png";